import { c as _c } from "react/compiler-runtime";
import { css } from '@repo/pandacss/css';
import type { SubcomponentProps } from '../../model/types';
import { ApplyNow } from '../ApplyNow';
import { Promotional as PromotionalBadge } from '../Badges/Promotional';
import { DriversContainer } from '../Drivers/Container';
import { ImageApplyNow } from '../ImageApplyNow';
import { OfferName } from '../OfferName';
import { StarRating } from '../StarRating';
const styles = {
  contentMainRow: css({
    display: 'grid',
    gridTemplateColumns: '[140px 1fr]',
    gridTemplateRows: '[auto auto auto]',
    gridTemplateAreas: '["offer offer" "image content" "apply apply"]',
    pt: '[0.7rem]',
    pb: '0',
    rowGap: '[0.7rem]',
    columnGap: '3',
    _pcMd: {
      display: 'flex',
      flexDirection: 'row',
      pt: '3',
      pb: '3',
      rowGap: '3.5',
      columnGap: '3.5'
    }
  }),
  contentImageArea: css({
    gridArea: 'image',
    _pcMd: {
      order: 1
    }
  }),
  contentOfferAndInfo: css({
    display: 'contents',
    _pcMd: {
      display: 'flex',
      flexDirection: 'column',
      width: '[100%]',
      order: 2
    }
  }),
  contentOfferName: css({
    gridArea: 'offer'
  }),
  contentInfoColumn: css({
    gridArea: 'content',
    display: 'flex',
    flexDirection: 'column',
    width: '[100%]'
  }),
  contentApplyNowWrapper: css({
    display: 'flex',
    minWidth: 'auto',
    gridArea: 'apply',
    _pcMd: {
      minWidth: '[256px]',
      order: 3
    }
  }),
  contentPromoBadgeMobile: css({
    display: 'flex',
    mt: '2',
    mb: '2',
    _pcMd: {
      display: 'none'
    }
  })
} as const;
export const Content = t0 => {
  const $ = _c(39);
  const {
    additionalApplyNowProps,
    creditCardOffer,
    ctaAnalytics,
    driverGroup,
    marketplacePayload,
    promotionalCopy,
    sectionIdentifier,
    segmentActionSection,
    shouldPrioritizeImage: t1,
    isLtoHighlightingEnabled: t2,
    trafficOriginType
  } = t0;
  const shouldPrioritizeImage = t1 === undefined ? false : t1;
  const isLtoHighlightingEnabled = t2 === undefined ? false : t2;
  const {
    id,
    imageOptions: t3,
    details: t4,
    name
  } = creditCardOffer;
  const {
    small: t5
  } = t3;
  const {
    url
  } = t5;
  const {
    reviewLink,
    starRating
  } = t4;
  const t6 = `product-card-${id}`;
  let t7;
  if ($[0] !== creditCardOffer || $[1] !== ctaAnalytics || $[2] !== shouldPrioritizeImage || $[3] !== url) {
    t7 = <div className={styles.contentImageArea}><ImageApplyNow creditCardOffer={creditCardOffer} ctaAnalytics={ctaAnalytics} src={url} shouldPrioritizeImage={shouldPrioritizeImage} /></div>;
    $[0] = creditCardOffer;
    $[1] = ctaAnalytics;
    $[2] = shouldPrioritizeImage;
    $[3] = url;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] !== creditCardOffer || $[6] !== ctaAnalytics) {
    t8 = <div className={styles.contentOfferName}><OfferName ctaAnalytics={ctaAnalytics} creditCardOffer={creditCardOffer} /></div>;
    $[5] = creditCardOffer;
    $[6] = ctaAnalytics;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== name || $[9] !== reviewLink || $[10] !== segmentActionSection || $[11] !== starRating) {
    t9 = <div className={styles.contentInfoColumn}><StarRating reviewLink={reviewLink} starRating={starRating} segmentActionSection={segmentActionSection} name={name} /></div>;
    $[8] = name;
    $[9] = reviewLink;
    $[10] = segmentActionSection;
    $[11] = starRating;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t8 || $[14] !== t9) {
    t10 = <div className={styles.contentOfferAndInfo}>{t8}{t9}</div>;
    $[13] = t8;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== additionalApplyNowProps || $[17] !== creditCardOffer || $[18] !== ctaAnalytics || $[19] !== sectionIdentifier) {
    t11 = <div className={styles.contentApplyNowWrapper}><ApplyNow ctaAnalytics={ctaAnalytics} creditCardOffer={creditCardOffer} sectionIdentifier={sectionIdentifier} additionalApplyNowProps={additionalApplyNowProps} /></div>;
    $[16] = additionalApplyNowProps;
    $[17] = creditCardOffer;
    $[18] = ctaAnalytics;
    $[19] = sectionIdentifier;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t10 || $[22] !== t11 || $[23] !== t6 || $[24] !== t7) {
    t12 = <div className={styles.contentMainRow} id={t6}>{t7}{t10}{t11}</div>;
    $[21] = t10;
    $[22] = t11;
    $[23] = t6;
    $[24] = t7;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== promotionalCopy) {
    t13 = promotionalCopy && <div className={styles.contentPromoBadgeMobile}><PromotionalBadge text={promotionalCopy} /></div>;
    $[26] = promotionalCopy;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== creditCardOffer || $[29] !== driverGroup || $[30] !== isLtoHighlightingEnabled || $[31] !== marketplacePayload || $[32] !== segmentActionSection || $[33] !== trafficOriginType) {
    t14 = <DriversContainer creditCardOffer={creditCardOffer} marketplacePayload={marketplacePayload} driverGroup={driverGroup} segmentActionSection={segmentActionSection} trafficOriginType={trafficOriginType} isLtoHighlightingEnabled={isLtoHighlightingEnabled} />;
    $[28] = creditCardOffer;
    $[29] = driverGroup;
    $[30] = isLtoHighlightingEnabled;
    $[31] = marketplacePayload;
    $[32] = segmentActionSection;
    $[33] = trafficOriginType;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== t12 || $[36] !== t13 || $[37] !== t14) {
    t15 = <div>{t12}{t13}{t14}</div>;
    $[35] = t12;
    $[36] = t13;
    $[37] = t14;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  return t15;
};